import { useForm } from "react-hook-form";
import { useState, useEffect, useRef } from "react";
import Modal from "./Modal";
import ModalRemove from "./ModalRemove";
import { useDispatch, useSelector } from "react-redux";
import {
  ObtenerTodos,
  Actualizar,
  Eliminar,
  Insertar,
} from "../../redux/razonesSlice";
import WindowDimension from "../../Hooks/WindowDimension";
import Required from "../../Components/Required";
import useSubmit from "../../Hooks/useSubmit";
import { OrderTable } from "../../Components/OrderTable";

const columns = [
  { label: "Código", accessor: "razonId", sortable: true },
  { label: "Nombre", accessor: "razonNombre", sortable: true },
  { label: "Acción", accessor: "action", sortable: false },
];

function Razones(props) {
  const [showModal, setShowModal] = useState(false);
  const [tituloModal, setTituloModal] = useState("Agregar");
  const [removeState, changeRemoveState] = useState(false);
  const [itemSelected, setItemSelected] = useState({});
  const { width } = WindowDimension();

  const dispatch = useDispatch();
  let busqueda = useRef();

  const { submitAction } = useSubmit();

  const { razones } = useSelector((state) => state.razones);

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
  } = useForm();

  const showModalEdit = (item) => {
    reset(item);
    setTituloModal("Editar");
    setShowModal(true);
  };

  const closeModalEdit = () => {
    reset({ razonId: 0, razonNombre: "" });
    setShowModal(false);
  };

  const showRemoveModalEdit = (item) => {
    setItemSelected(item);
    changeRemoveState(true);
  };

  const closeRemoveModalEdit = () => {
    setItemSelected({});
    changeRemoveState(false);
  };

  const cargarRazones = () => {
    dispatch(ObtenerTodos());
  };

  const cargarRazonesPorCaracter = () => {
    dispatch(ObtenerTodos(busqueda.current.value));
  };

  const eliminar = async () => {
    submitAction(Eliminar, itemSelected.razonId, () => {
      closeRemoveModalEdit();
      cargarRazones();
    });
  };

  const onSubmit = async (data) => {
    submitAction(data.razonId > 0 ? Actualizar : Insertar, data, () => {
      closeModalEdit();
      cargarRazones();
    });
  };

  useEffect(() => {
    cargarRazones();
  }, [dispatch]);

  return (
    <div className="main-admin">
      <div className="main-admin-bar">
        <div className="header-admin-bar-items">
          <button
            className="main-admin-button"
            onClick={() => {
              setShowModal(true);
              setTituloModal("Agregar");
              setValue("razonNombre", "");
              reset();
            }}
          >
            +
          </button>
          <h2>Razones para elegir CENFOTEC </h2>
        </div>

        <div className="header-admin-bar-items ml-auto">
          <label hidden>búsqueda</label>
          <input
            type="search"
            className="form-control"
            placeholder="Búsqueda"
            onInput={cargarRazonesPorCaracter}
            ref={busqueda}
          />
        </div>
      </div>

      <div className="table-container">
        {razones.length > 0 ? (
          <OrderTable
            {...{ columns }}
            data={razones}
            clase="table-adm"
            actions={[
              {
                icon: "",
                clase: "text-primary",
                style: { display: "contents" },
                event: (item) => showModalEdit(item),
              },
              {
                icon: "",
                clase: "delete",
                style: { display: "contents" },
                event: (item) => showRemoveModalEdit(item),
              },
            ]}
          />
        ) : (
          <div className="no-results-container">
            <img src={props.img} alt="Imagen sin resultados" />
            <h1>{props.noResultMessage}</h1>
          </div>
        )}
      </div>

      <Modal
        estado={showModal}
        cambiarEstado={closeModalEdit}
        titulo={tituloModal}
        clase={`${width < 576 ? "full-width" : "small"}`}
        buttonGroup={
          <>
            <button
              type="submit"
              className="button-text"
              onClick={handleSubmit(onSubmit)}
            >
              Guardar
            </button>
          </>
        }
      >
        <form>
          <div className="form-group">
            <label>Razón</label>
            <Required />
            <input
              className="form-control"
              name="razonNombre"
              {...register("razonNombre", { required: "Campo requerido" })}
            />
            {errors.razonNombre && (
              <p className="error">{errors.razonNombre.message}</p>
            )}
          </div>
        </form>
      </Modal>

      <ModalRemove
        estado={removeState}
        closeModalHandled={closeRemoveModalEdit}
        title="Eliminar plantillla"
        message="¿Seguro que desea eliminar el siguiente registro?"
        item={itemSelected.razonNombre}
        btnGroup={
          <>
            <button className="button-text text-red" onClick={eliminar}>
              Confirmar
            </button>
            <button
              className="button-text text-grey"
              onClick={() => {
                closeRemoveModalEdit(false);
              }}
            >
              Cancelar
            </button>
          </>
        }
      />
    </div>
  );
}

export default Razones;
